import { defineModule } from '@/core/define';
import { overridable } from '@/core/template-engine';

export default defineModule({
    id: 'luckyDraw',
    contributes: {
        'home.floating': [
            { key: 'rewardFloat', component: overridable('RewardFloat', () => import(/* webpackChunkName: "home" */ './components/RewardFloat.vue')) }
        ]
    }
});
